import React from 'react';

import HomeLanding from '../js/pages/HomeLanding';
import DashboardPage from '../js/pages/DashboardPage';
import PageContainer from '../js/components/PageContainer';
import {useAppContext} from '../js/hooks';

export default function Page() {
  const {currentUser} = useAppContext();

  return currentUser
    ? <DashboardPage />
    : <HomeLanding />;
}

// Dashboard for signed-in users, landing page otherwise, so the bg splits too.
const RootLayout = ({children}) => {
  const {currentUser} = useAppContext();

  return (
    <PageContainer stickyHeader className={currentUser ? 'bg-gray-50' : undefined}>
      {children}
    </PageContainer>
  );
};

Page.getLayout = (page) => <RootLayout>{page}</RootLayout>;
